import { MoneyLinkException } from "@/shared/utils/custom-exception";
import { ApiClient } from "@/shared/services/api-client";
import { PostEcshopTradesRequestModel, PostEcshopTradesResponseModel } from "@/features/accounts/ecshop/services/update-trades-model";

export class UpdateEcshopTradesApi {
  /**
   * その他連携明細更新API
   */
  public updateEcshopTrades = async (
    param: PostEcshopTradesRequestModel
  ): Promise<PostEcshopTradesResponseModel> => {
    const path = `/api/ecshopaccounts/ecshops/updatetrades`;
    const res = await ApiClient.instance.post<PostEcshopTradesResponseModel>({
      path: path,
      params: param as NonNullable<unknown>,
    });

    if (res.ok === false) {
      throw MoneyLinkException.fromServer({ response: res });
    }

    return res.body;
  };
}
